import { Stack, Typography } from '@mui/material';
import Analytics from './Analytics';
import { H2 } from 'app/components/Typography';
import React, { useEffect } from 'react';

const Dashboard = () => {
  const [opacity, setOpacity] = React.useState(0.5);

  useEffect(() => {
    const interval = setInterval(() => {
      setOpacity((prev) => (prev >= 1 ? 0.5 : prev + 0.1));
    }, 100);

    return () => clearInterval(interval);
  }, []);
  return (
    <div>
      <H2>Dashboard</H2>
      <Stack
        spacing={2}
        my={3}
        style={{
          opacity: opacity
        }}
      >
        {/* <Typography variant="h4" sx={{ mb: 2, color: 'red', textAlign: 'center' }} mt={2}>
          *** Wordpress , Pinterest & Instagram schedulers are suspended due to midjourney API
          changes. No automatic post generation for now. We are working on a fix. ***
        </Typography> */}
      </Stack>
      <Analytics />
    </div>
  );
};

export default Dashboard;
